import RootState from 'typings/RootState'
import { Event } from 'Store/common/common.types'
import { ListData, RoleData } from './types'

export const selectRoleListEvent = (state: RootState): Event => state.manageRoleReducer.listEvent

export const selectRoleList = (state: RootState): ListData => state.manageRoleReducer.list

export const selectRoleActionEvent = (state: RootState): Event => state.manageRoleReducer.actionEvent

export const selectRoleDetail = (state: RootState): RoleData | undefined => state.manageRoleReducer.detail

export const selectRoleDetailEvent = (state: RootState): Event => state.manageRoleReducer.detailEvent
